import {
  getImageBase64,
  getBackground,
  getThemePic,
} from "@/views/home/slidePPT/use/methods";
import { pathToBase64 } from "@/utils";

export default async function (data) {
  const node = data.node;
  const catalogueList = node.list || node.children;
  const color = data.color;
  let htmlText = "<ul>";
  for (let i = 0; i < catalogueList.length; i++) {
    const item = catalogueList[i];
    htmlText += `<li style=\"text-align: left;\"><span style=\"font-size: 24.49px;font-family: Microsoft Yahei;\">${item}</span></li>`;
  }
  htmlText += "</ul>";
  const id = Math.random().toString(36).slice(-8);
  const background = await getBackground(data?.customTheme, "catalogue");

  return {
    id: id,
    elements: [
      {
        type: "shape",
        id: "-mVVgb1xe1",
        width: 148.57,
        height: 37.76,
        left: 59.86078665077473,
        top: 124.91499999999999,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: "none",
        fixedRatio: false,
        rotate: 0,
        text: {
          content:
            '<p style="text-align: justify;"><span style="font-size: 24.49px;"><span style="font-family: 思源黑体 CN Heavy;"><span style="color: #000000;">Contents</span></span></span></p>',
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "top",
        },
        flipH: false,
        flipV: false,
      },
      {
        type: "shape",
        id: "H0RgLOHbYs",
        width: 131.35,
        height: 68.07,
        left: 49.84,
        top: 50.31,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: "none",
        fixedRatio: false,
        rotate: 0,
        text: {
          content:
            '<p style="text-align: center;"><strong><span style="font-size: 48.98px;"><span style="font-family: 思源黑体 CN Heavy;"><span style="color: #000000;">目录</span></span></span></strong></p>',
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "top",
        },
        flipH: false,
        flipV: false,
      },
      {
        type: "text",
        id: "V33g5l5bYX",
        width: 490.77028871391076,
        height: 190,
        left: 438.38435695538055,
        top: 200.3059317585302,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        content: htmlText,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
    ],

    background,
  };
}
